import { assetsUrl } from './api/common'

export const getExternalImg = (symbol: string): string => {
  return `${assetsUrl}/${symbol.toLowerCase()}.svg`
}
export const getCoinSGV = (symbol: string): string => {
  return `${assetsUrl}/coins/${symbol.toLowerCase()}.svg`
}
